import { styled } from '@/stitches.config';
import { Box } from '@base-app';
import { ReactComponent as OutreachIcon } from '@assets/icons/outreach.svg';
import { ReactComponent as GeneticCounselingSVG } from '@assets/icons/genetic-counseling-icon.svg';
import { ReactComponent as StudyInsightsIcon } from '@assets/icons/study-insights-icon.svg';
import { ReactComponent as HrnWithdrawalIcon } from '@/assets/icons/hrn-withdrawal.svg';

export const MainLayoutWrapperStyled = styled(Box, {
  height: '100%',
  width: '100%',
});

export const StudyInsightsIconStyled = styled(StudyInsightsIcon, {
  height: '$8',
  width: '$8',
});

export const CommunityOutreachIcon = styled(OutreachIcon, {
  height: '$8',
  width: '$8',
});

export const GeneticCounselingIcon = styled(GeneticCounselingSVG, {
  height: '$8',
  width: '$8',
});

export const HrnWithdrawalStyled = styled(HrnWithdrawalIcon, {
  height: '$8',
  width: '$8',
});
